<p-toast></p-toast>
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<p-toolbar styleClass="p-mb-4">
    <ng-template pTemplate="left">
        <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
            (click)="goBack()"></button>
    </ng-template>
</p-toolbar>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>

<p-fieldset>   
    <ng-template pTemplate="header">{{translations.lbl_FI_offer_statistics}}</ng-template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <!-- Configurations -->
                <div class="p-fluid" [formGroup]="globalUserDataForm">
                    <!-- GENERAL DATA -->
                    <div class="p-col-6">
                        <label >{{translations.lbl_coordination}}:</label>
                        <input id="coordination"  type="text" maxlength="30" [disabled]="true"
                        pInputText value="{{coordName}}"
                        >
                    </div>
                    <!-- YEAR -->
                    <div class="p-col-6">
                        <label for="year"> {{translations.lbl_year}}: </label>
                        <p-dropdown
                            id="year"
                            [options]="listYears"  
                            placeholder="{{translations.lbl_select}} {{translations.lbl_year}}" 
                            formControlName="selectedYear"
                            optionLabel="year"
                            (onChange)="getListStatistForFI()"
                            [showClear]="true" >
                        </p-dropdown>
                    </div>
                    <!-- PERIOD -->
                    <div class="p-col-6">
                        <label for="selectPeriod">{{translations.lbl_period}}:  </label>
                        <div class="p-d-flex p-ai-left p-jc-around ">
                            <div *ngFor="let period of periods" class="field-checkbox">
                                <p-radioButton  [inputId]="period.key" [value]="period" formControlName="selectedPeriod" (onClick)="getListStatistForFI()"></p-radioButton>
                                <label [for]="period.key" class="ml-2">{{ period.name }}</label>
                            </div>
                        </div>
                    </div>
                    <!-- To Currency -->
                    <div class="p-col-6">
                        <label for="year">{{translations.lbl_to}} {{translations.lbl_currency}}: </label>
                        <p-dropdown 
                            id="currencyForm"
                            [options]="listCurrencies" 
                            placeholder="{{translations.lbl_select}} {{translations.lbl_currency}}" 
                            formControlName="selectedCurrency"
                            optionLabel="value"
                            (onChange)="getListStatistForFI()"
                            [showClear]="true">
                        </p-dropdown>
                    </div>
                </div>

                <!-- TABLE -->
                <p-table 
                [paginator]="true" [rows]="40" [showCurrentPageReport]="false" 
                responsive="true"
                [value]="data">


                <!-- CAPTION -->
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between responsive">
                        <div>
                            <button type="button" pButton pRipple icon="pi pi-file-excel"
                                class="p-button-success p-m-2 z-5" pTooltip="XLS" tooltipPosition="bottom" (click)="onClickDownloadFile()">
                            </button>

                            <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-m-2 z-5" pTooltip="{{translations.lbl_update}}"
                                (click)="getListStatistForFI()">
                            </button>
                        </div>

                        <div class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" placeholder="{{translations.lbl_search}}..." />
                        </div>
                    </div>
                </ng-template>

                <!-- TABLE HEADERS -->
                <ng-template pTemplate="header">
                    <tr>
                       <th rowspan="3" class="p-text-center"></th>
                       <th rowspan="3" class="p-text-center">{{translations.lbl_coordination}}</th>
                       <th rowspan="3" class="p-text-center"># {{translations.lbl_worked}}</th>
                       <th colspan="12" class="p-text-center">{{translations.lbl_number}}</th>
                       <th colspan="7" class="p-text-center">$ {{translations.lbl_offering}}</th>
                    </tr>
                    <tr>
                        <th colspan="2" class="p-text-center">{{translations.lbl_adults}}</th>
                        <th colspan="2" class="p-text-center">{{translations.lbl_youngs}}</th>
                        <th colspan="2" class="p-text-center">{{translations.lbl_adolescents}}</th>
                        <th colspan="2" class="p-text-center">{{translations.lbl_children}}</th>
                        <th colspan="2" class="p-text-center">{{hourLabelsTranslated.mar_cour}}</th>
                        <th colspan="2" class="p-text-center">{{translations.lbl_school_prep_guides}}</th>
                        <th colspan="7"></th>
                     </tr>
                     <tr>
                        <th># {{translations.lbl_abrTall}}</th>
                        <th># {{translations.lbl_abrTall}} {{translations.lbl_2ndSes}}</th>
                        <th># {{translations.lbl_abrTall}}</th>
                        <th># {{translations.lbl_abrTall}} {{translations.lbl_1stSes}}</th>
                        <th># {{translations.lbl_abrTall}}</th>
                        <th># {{translations.lbl_abrTall}} {{translations.lbl_1stReu}}</th>
                        <th># {{translations.lbl_abrTall}}</th>
                        <th># {{translations.lbl_abrTall}} {{translations.lbl_1stReu}}</th>
                        <th># {{hourLabelsTranslated.plw_mar_cour}}</th>
                        <th># {{translations.lbl_partic_partner}}</th>
                        <th># {{hourLabelsTranslated.plw_sfpg}}</th>
                        <th># {{translations.lbl_future_guide}}</th>
                        <th>{{hourLabelsTranslated.plw_adults}}</th>
                        <th>{{hourLabelsTranslated.plw_yadults}}</th>
                        <th>{{hourLabelsTranslated.plw_adol}}</th>
                        <th>{{hourLabelsTranslated.plw_child}}</th>
                        <th>{{hourLabelsTranslated.plw_mar_cour}}</th>
                        <th>{{hourLabelsTranslated.plw_sfpg}}</th>
                        <th>{{translations.lbl_total}}</th>
                     </tr>
                </ng-template>

                <!-- TABLE BODY -->
                <ng-template pTemplate="body"  let-data>
                    <tr>
                        <td>
                            <button  *ngIf="data.storeType == 'L'" type="button" pButton pRipple icon="pi pi-search"
                                (click)="redirectoToJrnHGuideReferInc(data.storeId)" pTooltip="{{translations.lbl_select}}">
                            </button>
                        </td>
                        <td> {{data.guiType}} {{data.strDescri}}</td>
                        <td>{{data.wrkGuides}}</td>
                        <td>{{data.totServicesAdu}}</td>
                        <td>{{data.totParticp2sAdu}}</td>
                        <td>{{data.totServicesYng}}</td>
                        <td>{{data.totParticp2sYng}}</td>
                        <td>{{data.totServicesTee}}</td>
                        <td>{{data.totParticp2sTee}}</td>
                        <td>{{data.totServicesChi}}</td>
                        <td>{{data.totParticp2sChi}}</td>
                        <td>{{data.totServicesMar}}</td>
                        <td>{{data.totParticp2sMar}}</td>
                        <td>{{data.totServicesSTII}}</td>
                        <td>{{data.totParticp2sSTII}}</td>
                        <!-- PLW ADU -->
                        <td>{{data.totOfferingAdu | number:'1.2-2'}}</td>
                        <!-- PLW YADU -->
                        <td>{{data.totOfferingYng | number:'1.2-2'}}</td>
                        <!-- PLW ADOL -->
                        <td>{{data.totOfferingTee | number:'1.2-2'}}</td>
                        <!-- PLW CHIL -->
                        <td>{{data.totOfferingChi | number:'1.2-2'}}</td>
                        <!-- MAR COUR -->
                        <td>{{data.totOfferingMar | number:'1.2-2'}}</td>
                        <!-- SFPG -->
                        <td>{{data.totOfferingSTII | number:'1.2-2'}}</td>
                        <!-- Total -->
                        <td>{{sumColumns(data) | number:'1.2-2'}}</td> 
                    </tr>
                </ng-template>

                <!-- TABLE FOOTER -->
                <ng-template pTemplate="footer">
                    <td><strong>{{translations.lbl_total}}</strong></td>
                        <td colspan="14"></td>
                        <!-- PLW ADU -->
                        <td>{{sumRows('totOfferingAdu') | number:'1.2-2'}}</td>
                        <!-- PLW YADU -->
                        <td>{{sumRows('totOfferingYng') | number:'1.2-2'}}</td>
                        <!-- PLW ADOL -->
                        <td>{{sumRows('totOfferingTee') | number:'1.2-2'}}</td>
                        <!-- PLW CHIL -->
                        <td>{{sumRows('totOfferingChi') | number:'1.2-2'}}</td>
                        <!-- MAR COUR -->
                        <td>{{sumRows('totOfferingMar') | number:'1.2-2'}}</td>
                        <!-- SFPG -->
                        <td>{{sumRows('totOfferingSTI') | number:'1.2-2'}}</td>
                        <!-- Total -->
                        <td>{{totalRows() | number:'1.2-2' }}</td>
                </ng-template>

                <!-- EMPTY -->
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns ? columns.length : 1">
                            {{translations.lbl_no_records_found}}
                        </td>
                    </tr>
                </ng-template>

                <!-- SUMMARY -->
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{translations.lbl_there_are}} {{data != null ? data.length : 0 }}
                        {{translations.lbl_records}}.
                    </div>
                </ng-template>
            </p-table>
            </div>
        </div>
    </div>
</p-fieldset>